/**
 * This is a higher-order component used to provide a deprecation
 * warning in the console (except in production mode).
 */
import { __assign } from "tslib";
import * as React from 'react';
export var warnDeprecated = function (Component, message) {
    return function (props) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(message);
        }
        return React.createElement(Component, __assign({}, props));
    };
};
//# sourceMappingURL=warnDeprecated.js.map